/* globals axios */
import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('cooking-mode-component', {
    // props
    props: {
        bgcolor: {
            type: String,
        },
        contentcolor: {
            type: String,
        },
        fillcolor: {
            type: String,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            cookingMode: false,
            backgroundColor: '',
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        console.log('bgcolor', this.bgcolor);

        console.log('fillColor', this.fillcolor);

        this.backgroundColor = window.getComputedStyle(document.querySelector(`.bg-color--${this.bgcolor}`)).backgroundColor;
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleCookingMode() {
            this.cookingMode = !this.cookingMode;

            if (this.cookingMode) {
                this.animateToggleOn();
                this.enableWakeLock();
            } else {
                this.animateToggleOff();
                this.disableWakeLock();
            }
        },
        async enableWakeLock() {
            try {
                this.wakeLock = await navigator.wakeLock.request('screen');
            } catch (err) {
                console.error(`${err.name}, ${err.message}`);
            }
        },
        async disableWakeLock() {
            if (this.wakeLock !== null) {
                await this.wakeLock.release();
                this.wakeLock = null;
            }
        },
        animateToggleOn() {
            gsap.to('.toggle-circle', { cx: 40, fill: this.backgroundColor, duration: 0.3 });
            gsap.to('.toggle-rect', { fill: this.fillcolor, stroke: this.fillcolor, duration: 0.3 });
        },
        animateToggleOff() {
            gsap.to('.toggle-circle', { cx: 12, fill: this.fillcolor, duration: 0.3 });
            gsap.to('.toggle-rect', { fill: 'none', stroke: this.fillcolor, duration: 0.3 });
        },
    },
});
